import { useEffect, useState, useRef, useCallback } from "react"
import ConfigurationDialog from "../map/drawingTools/_configurationDialog"
import { Form, Button, Modal, Table } from "react-bootstrap"
import Textbox from "../form/textbox"
import SimpleBar from "simplebar-react"
import enums from "../../utilities/enums"
import arrayUtilities from "../../utilities/arrayUtilities"
import pointUtilities from "../../utilities/pointUtilities"
import stringUtilities from "../../utilities/stringUtilities"
import { ReorderingWrapper } from "./reorderingWrapper"
import { ReorderingRowWrapper } from "./reorderingRowWrapper"
import { WorkflowConfigFieldsForm } from './formsCreateEdit/workflowConfigFieldsForm';
import { DragHandlerIcon } from "./dragHandlerIcon"
import { arrayMove } from "@dnd-kit/sortable";
import { DragOverlay } from "@dnd-kit/core"
import { ConfigFormRowDragOverlay } from "./configFormRowDragOverlay"
import FilterBar from "./filterBar";
import Loading from "./loading";

export const WorkflowConfigBuilder = ({ configType, setConfigType, isEditingTypeIndex, setIsEditingTypeIndex, saveConfig, typeFormData, setTypeFormData, icons, isLoadingIcons, workflowHasData }) => {

    const [name, setName] = useState(null)
    const [iconUrl, setIconUrl] = useState(null)
    const [showImageDialog, setShowImageDialog] = useState(false)
    const [geometryType, setGeometryType] = useState("Point")
    const [showFieldsForm, setShowFieldsForm] = useState(false)
    const [showAttachmentFieldsForm, setShowAttachmentFieldsForm] = useState(false)
    const [editedFieldsFormData, setEditedFieldsFormData] = useState(null)
    const [editedAttachmentFieldsFormData, setEditedAttachmentFieldsFormData] = useState(null)
    const [fieldsSortingArray, setFieldsSortingArray] = useState([])
    const [attachmentFieldsSortingArray, setAttachmentFieldsSortingArray] = useState([])
    const [attachmentTypesSortingArray, setAttachmentTypesSortingArray] = useState([])
    const [allowPhotos, setAllowPhotos] = useState(false)
    const [isNormallyVisible, setIsNormallyVisible] = useState(false)
    const [color, setColor] = useState(null)
    const [isDashed, setIsDashed] = useState(false)
    const [editableAttachmentTypeIndex, setEditableAttachmentTypeIndex] = useState(null)
    const [attachmentType, setAttachmentType] = useState(null)
    const [showAttachmentTypesModal, setShowAttachmentTypesModal] = useState(false)
    const [canSave, setCanSave] = useState(false)
    const [editableConfigFieldIndex, setEditableConfigFieldIndex] = useState(null)
    const [deleteItem, setDeleteItem] = useState(null)
    const [activeItem, setActiveItem] = useState(null)
    const [filter, setFilter] = useState("");
    const observer = useRef(null);

    const [filteredIcons, setFilteredIcons] = useState(null);
    const debouncedSearchRef = useRef(null);

    const [opened, setOpened] = useState({});

    const toggle = (name) => {
        setOpened(prev => ({ ...prev, [name]: !prev[name] }));
    };

    useEffect(() => {
        setName(typeFormData && typeFormData.hasOwnProperty("name") ? typeFormData.name : null)

        setIconUrl(typeFormData && typeFormData.hasOwnProperty("iconUrl") ? typeFormData.iconUrl : null)

        setFilteredIcons(icons);

        setGeometryType(typeFormData && typeFormData.hasOwnProperty("geometryType") ? typeFormData.geometryType : "Point")

        setFieldsSortingArray(typeFormData && typeFormData.hasOwnProperty("fields") && !arrayUtilities.isNullOrEmpty(typeFormData.fields) ? typeFormData.fields : [])

        setAttachmentTypesSortingArray(typeFormData && typeFormData.hasOwnProperty("attachmentTypes") && !arrayUtilities.isNullOrEmpty(typeFormData.attachmentTypes) ? typeFormData.attachmentTypes : [])

        setAttachmentFieldsSortingArray(typeFormData && typeFormData.hasOwnProperty("attachmentFields") && !arrayUtilities.isNullOrEmpty(typeFormData.attachmentFields) ? typeFormData.attachmentFields : [])

        setIsNormallyVisible(typeFormData && typeFormData.hasOwnProperty("isNormallyVisible") && typeFormData.isNormallyVisible !== undefined ? typeFormData.isNormallyVisible : false)

        setAllowPhotos(typeFormData && typeFormData.hasOwnProperty("allowPhotos") && typeFormData.allowPhotos !== undefined ? typeFormData.allowPhotos : false)

        setColor(typeFormData && typeFormData.hasOwnProperty("color") && !stringUtilities.isNullOrEmpty(typeFormData.color) ? typeFormData.color : null)

        setIsDashed(typeFormData && typeFormData.hasOwnProperty("isDashed") && typeFormData.isDashed !== undefined ? typeFormData.isDashed : false)
    }, [typeFormData])

    const onSave = () => {
        const payloadObject = {
            name: name,
            iconUrl: iconUrl,
            geometryType: geometryType,
            fields: fieldsSortingArray,
            attachmentTypes: attachmentTypesSortingArray,
            attachmentFields: attachmentFieldsSortingArray,
            isNormallyVisible: isNormallyVisible,
            allowPhotos: allowPhotos,
            color: color,
            isDashed: isDashed
        }
        saveConfig(configType, payloadObject)
    }

    useEffect(() => setCanSave(!stringUtilities.isNullOrEmpty(name)), [name])    

    const addAttachmentType = () => {
        setAttachmentTypesSortingArray(prevState => [...prevState, attachmentType])
        setAttachmentType("")
        setShowAttachmentTypesModal(false)
    }

    const editAttachmentType = (index) => {
        const newAttachmentTypeSortingArray = attachmentTypesSortingArray.toSpliced(index, 1, attachmentType)
        setAttachmentTypesSortingArray(newAttachmentTypeSortingArray)
        setAttachmentType("")
        setShowAttachmentTypesModal(false)
    }

    const addConfigFields = (fieldsType, fieldsFormData) => {
        if (fieldsType === "fields") {
            setFieldsSortingArray(prevState => [...prevState, fieldsFormData])
        } else if (fieldsType === "attachmentFields") {
            setAttachmentFieldsSortingArray(prevState => [...prevState, fieldsFormData])
        }
        setEditableConfigFieldIndex(null)
        setEditedFieldsFormData(null)
        setEditedAttachmentFieldsFormData(null)
    }

    const editConfigFields = (fieldsType, fieldsFormData, index) => {
        if (fieldsType === "fields") {
            const newFieldsSortingArray = fieldsSortingArray.toSpliced(index, 1, fieldsFormData)
            setFieldsSortingArray(newFieldsSortingArray)
        } else if (fieldsType === "attachmentFields") {
            const newAttachmentFieldsSortingArray = attachmentFieldsSortingArray.toSpliced(index, 1, fieldsFormData)
            setAttachmentFieldsSortingArray(newAttachmentFieldsSortingArray)
        }
        setEditableConfigFieldIndex(null)
        setEditedFieldsFormData(null)
        setEditedAttachmentFieldsFormData(null)
    }

    const deleteRowItem = ({index, stateArray, setStateCallback}) => {
        const newStateArray = stateArray.toSpliced(index, 1)
        setStateCallback(newStateArray)
        setDeleteItem(null)
    }

    useEffect(() => {
        setFilteredIcons(icons);
    }, [icons]);

    useEffect(() => {
        if (debouncedSearchRef.current) {
            debouncedSearchRef.current(filter);
        }
    }, [filter]);

    useEffect(() => {
        debouncedSearchRef.current = debounce((searchText) => {
            setFilteredIcons(searchIcons(icons, searchText));
        }, 300);
    }, [icons]);

    function debounce(func, delay) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    const searchNode = (node, searchText) => {
        if (!node) return null;

        setOpened(prev => ({ ...prev, [node.name]: node.name }));

        const searchLower = searchText.toLowerCase();

        const filteredImages = (node.images || []).filter(img =>
            img.name.toLowerCase().includes(searchLower)
        );

        const filteredFolders = (node.folders || [])
            .map(sub => searchNode(sub, searchText))
            .filter(sub => sub !== null);

        if (filteredImages.length > 0 || filteredFolders.length > 0) {
            return {
                ...node,
                images: filteredImages,
                folders: filteredFolders
            };
        }

        return null;
    }

    const searchIcons = (nodes, searchText) => {
        if (!nodes) return null;
        if (!searchText) {
            setOpened({});
            return icons;
        }

        return nodes
            .map(node => searchNode(node, searchText))
            .filter(node => node !== null);
    }

    useEffect(() => {
        observer.current = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.src = entry.target.dataset.url;
                }
            });
        });

        return () => observer.current.disconnect();
    }, []);

    const observeImage = useCallback(node => {
        if (!node) return;
        observer.current.observe(node);
    }, []);

    const renderTree = (node) => {
        if (!node) return null;

        const isOpened = opened[node.name];

        return (
            <ul key={node.name} className={!isOpened ? "ul-container collapsed" : "ul-container"}>
                <li>
                    <a className="d-flex align-items-center" onClick={(e) => {e.stopPropagation(); toggle(node.name)}}>
                        <i class={isOpened ? 'fi-folder-minus' : 'fi-folder-plus'}></i>
                        {node.name}
                    </a>
                    {!arrayUtilities.isNullOrEmpty(node.images) && (
                        <ul>
                            {node.images.map(img => (
                                <li className="d-flex icon-container" key={img.url} onClick={(e) => { setIconUrl(img.url); setShowImageDialog(false); setFilter(null); }}>
                                    <img className="icon" ref={observeImage} data-url={pointUtilities.getBaseSlugForIcons() + img.url} loading="lazy" style={{width: 16}} />
                                    <p className="icon-name">{img.name}</p>
                                </li>
                            ))}
                        </ul>
                    )}
                    {
                        node.folders && node.folders.map(sub => renderTree(sub))
                    }
                </li>
            </ul>
        );
    };

    return (
        <>
            <ConfigurationDialog
                show={ configType }
                title={ `${ isEditingTypeIndex !== null ? "Edit" : "Add" } Type` }
                onSave={ () => onSave() }
                onCancel={ () => {
                    setConfigType(null)
                    setIsEditingTypeIndex(null)
                    setTypeFormData(null)
                } }
                preventSave={ !canSave }
            >
                <Form.Group className='mb-3 row'>
                    <Form.Label className='form-label fs-sm col-form-label'>Name</Form.Label>
                    <div>
                        <Form.Control size='sm' value={ name } type="text" onChange={ (e) => setName(e.target.value) } />
                        {
                            typeFormData && workflowHasData && 
                            name !== typeFormData?.name && 
                            <>
                                <small className="text-danger"><i className="fi-alert-circle"></i> This workflow has data attached to it. Editing the type name could lead to loss of data. Please proceed with caution. </small> 
                                <Button onClick={() => setName(typeFormData && typeFormData.hasOwnProperty("name") ? typeFormData.name : null)} variant="secondary" size="xs">
                                    <span className="d-flex align-items-center"><i className="fi-rotate-left me-2"></i> Reset</span>
                                </Button>
                            </>
                        }
                    </div>
                </Form.Group>
                <Form.Group className='mb-3 row'>
                    <Form.Label className='form-label fs-sm col-form-label'>Geometry Type</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Select size='sm' defaultValue="0" value={ geometryType } onChange={ (e) => setGeometryType(e.target.value) }>
                            { Object.entries(enums.GeometryType).map(([key, value]) => <option key={ key } value={ value }>{ value }</option>) }
                        </Form.Select>
                    </div>
                </Form.Group>
                <Form.Group className='mb-3 align-items-center'>
                    <Form.Label className='form-label fs-sm col-form-label d-flex align-items-center justify-content-between' htmlFor="types-fields">
                        Fields <Button size="xs" variant="secondary" onClick={ () => setShowFieldsForm(true) } className='ms-2'><i className='fi-plus me-2'></i>Add</Button>
                    </Form.Label>
                    {
                        !arrayUtilities.isNullOrEmpty(fieldsSortingArray) &&
                        <ReorderingWrapper
                            handleDragStart={event => {
                                const { active } = event
                                setActiveItem(fieldsSortingArray.find((_, index) => index === Number(active.id)))
                            }}
                            sortingArray={ fieldsSortingArray }
                            handleDragEndTable={ event => {
                                const { active, over } = event
                                if (active.id !== over.id) {
                                    const reOrderedArray = arrayMove(fieldsSortingArray, event.active.id, event.over.id)
                                    setFieldsSortingArray(reOrderedArray)
                                    setActiveItem(null)
                                }
                            } }>
                            <Table hover className="workflow-config-table config-form-table">
                                <tbody>
                                    {
                                        fieldsSortingArray.map(
                                            (item, index) => <ReorderingRowWrapper id={ index }>
                                                <td className="pt-3"><DragHandlerIcon /></td>
                                                <td>{ item.name }</td>
                                                <td className="text-end">
                                                    <i onClick={ () => {
                                                        setEditedFieldsFormData(item)
                                                        setShowFieldsForm(true)
                                                        setEditableConfigFieldIndex(index)
                                                    } } role='button' className='fi-edit me-2'></i>
                                                    <i onClick={ () => setDeleteItem({ section: "Field", index: index, stateArray: fieldsSortingArray, setStateCallback: setFieldsSortingArray }) } role='button' className='fi-trash'></i>
                                                </td>
                                            </ReorderingRowWrapper>
                                        )
                                    }
                                </tbody>
                            </Table>
                            {
                            activeItem !== null  &&
                                <DragOverlay>
                                    <ConfigFormRowDragOverlay item={activeItem} />
                                </DragOverlay>
                            }
                        </ReorderingWrapper>
                    }
                </Form.Group>
                <Form.Group className='mb-3 align-items-center'>
                    <Form.Label className='form-label fs-sm col-form-label d-flex align-items-center justify-content-between' htmlFor="types-fields">
                        Attachment Types <Button size="xs" variant="secondary" onClick={ () => setShowAttachmentTypesModal(true) } className='ms-2'><i className='fi-plus me-2'></i>Add</Button>
                    </Form.Label>
                    {
                        !arrayUtilities.isNullOrEmpty(attachmentTypesSortingArray) &&
                        <ReorderingWrapper handleDragStart={event => {
                                const { active } = event
                                setActiveItem(attachmentTypesSortingArray.find((_, index) => index === Number(active.id)))
                            }} 
                            sortingArray={ attachmentTypesSortingArray } handleDragEndTable={ event => {
                            const { active, over } = event
                            if (active.id !== over.id) {
                                const reOrderedArray = arrayMove(attachmentTypesSortingArray, event.active.id, event.over.id)
                                setAttachmentTypesSortingArray(reOrderedArray)
                                setActiveItem(null)
                            }
                        } }>
                            <Table hover className="workflow-config-table config-form-table">
                                <tbody>
                                    {
                                        attachmentTypesSortingArray.map(
                                            (item, index) => <ReorderingRowWrapper id={ index }>
                                                <td className="pt-3"><DragHandlerIcon /></td>
                                                <td>{ item }</td>
                                                <td className="text-end">
                                                    <i onClick={ () => {
                                                        setShowAttachmentTypesModal(true); setAttachmentType(item); setEditableAttachmentTypeIndex(index)
                                                    } } role='button' className='fi-edit me-2'></i>
                                                    <i onClick={ () => setDeleteItem({ section: "Attachment Type", index: index, stateArray: attachmentTypesSortingArray, setStateCallback: setAttachmentTypesSortingArray }) } role='button' className='fi-trash'></i>
                                                </td>
                                            </ReorderingRowWrapper>
                                        )
                                    }
                                </tbody>
                            </Table>
                            {
                            activeItem !== null  &&
                                <DragOverlay>
                                    <ConfigFormRowDragOverlay item={activeItem} />
                                </DragOverlay>
                            }
                        </ReorderingWrapper>
                    }
                </Form.Group>

                <Form.Group className='mb-3 align-items-center'>
                    <Form.Label className='form-label fs-sm col-form-label d-flex align-items-center justify-content-between' htmlFor="types-fields">
                        Attachment Fields <Button size="xs" variant="secondary" onClick={ () => setShowAttachmentFieldsForm(true) } className='ms-2'><i className='fi-plus me-2'></i>Add</Button>
                    </Form.Label>
                    {
                        !arrayUtilities.isNullOrEmpty(attachmentFieldsSortingArray) &&
                        <ReorderingWrapper sortingArray={ attachmentFieldsSortingArray }
                        handleDragStart={event => {
                                const { active } = event
                                setActiveItem(attachmentFieldsSortingArray.find((_, index) => index === Number(active.id)))
                            }}
                        handleDragEndTable={ event => {
                            const { active, over } = event
                            if (active.id !== over.id) {
                                const reOrderedArray = arrayMove(attachmentFieldsSortingArray, event.active.id, event.over.id)
                                setAttachmentFieldsSortingArray(reOrderedArray)
                                setActiveItem(null)
                            }
                        } }>
                            <Table hover className="workflow-config-table config-form-table">
                                <tbody>
                                    {
                                        attachmentFieldsSortingArray.map(
                                            (item, index) => <ReorderingRowWrapper id={ index }>
                                                <td className="pt-3"><DragHandlerIcon /></td>
                                                <td>{ item.name }</td>
                                                <td className="text-end">
                                                    <i onClick={ () => {
                                                        setEditedAttachmentFieldsFormData(item)
                                                        setShowAttachmentFieldsForm(true)
                                                        setEditableConfigFieldIndex(index)
                                                    } } role='button' className='fi-edit me-2'></i>
                                                    <i onClick={ () => setDeleteItem({ section: "Attachment Field", index: index, stateArray: attachmentFieldsSortingArray, setStateCallback: setAttachmentFieldsSortingArray }) } role='button' className='fi-trash'></i>
                                                </td>
                                            </ReorderingRowWrapper>
                                        )
                                    }
                                </tbody>
                            </Table>
                            {
                            activeItem !== null  &&
                                <DragOverlay>
                                    <ConfigFormRowDragOverlay item={activeItem} />
                                </DragOverlay>
                            }
                        </ReorderingWrapper>
                    }
                </Form.Group>
                <Form.Group className='mb-3 row align-items-center'>
                    <Form.Label className='form-label fs-sm col-form-label' htmlFor="types-normally-visible">
                        Normally Visible
                    </Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Check type='switch' id="types-normally-visible" checked={ isNormallyVisible } onChange={ e => setIsNormallyVisible(e.target.checked) } />
                    </div>
                </Form.Group>
                <Form.Group className='mb-3 row align-items-center'>
                    <Form.Label className='form-label fs-sm col-form-label' htmlFor="types-allow-photos">
                        Allow Photos
                    </Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Check type='switch' id="types-allow-photos" checked={ allowPhotos } onChange={ e => setAllowPhotos(e.target.checked) } />
                    </div>
                </Form.Group>
                <Form.Group>
                    <Form.Label className='form-label fs-sm col-form-label' htmlFor="types-allow-photos">
                        Icon
                    </Form.Label>
                    <div className="d-flex align-items-center justify-content-between">
                        {
                            !stringUtilities.isNullOrEmpty(iconUrl) &&
                            <img src={pointUtilities.getBaseSlugForIcons() + iconUrl} style={{width: 40}} loading="lazy" />
                        }
                        <div className="ms-auto">
                            {
                                !stringUtilities.isNullOrEmpty(iconUrl) &&
                                <Button className="me-2" size="xs" variant='secondary' onClick={() => setIconUrl(null)}>Clear Icon</Button>
                            }
                            <Button size="xs" variant='secondary' onClick={() => setShowImageDialog(true)}>Select Icon</Button>
                        </div>
                    </div>
                </Form.Group>
                <Form.Group className='mb-3 row'>
                    <Form.Label className='form-label fs-sm col-form-label'>Color</Form.Label>
                    <div className="d-flex">
                        <div className='color-picker'>
                            <Form.Control id="workflow-config-color-picker" value={ color ?? "#000000" } type="color" onChange={ (e) => setColor(e.target.value ) } className={ `color-display ${ color ? "visible" : "invisible" }` } />
                            <div onClick={ () => {
                                const picker = document.querySelector("#workflow-config-color-picker");
                                picker.showPicker()
                            } } className={ `color-display null-display ${ color ? "invisible" : "visible" }` }>
                            </div>
                        </div>
                        <div className='d-flex gap-2 align-items-center'>
                            <p className="m-0 mt-2">{ color ?? "None" }</p>
                            { color && <button className='btn btn-link fi-x m-0 p-1 mt-2' onClick={ () => setColor(null) }></button> }
                        </div>
                    </div>
                </Form.Group>
                {
                    pointUtilities.geometryIsLineOrPolygon(geometryType) &&
                    <Form.Group className='mb-3 row align-items-center'>
                        <Form.Label className='form-label fs-sm col-form-label' htmlFor="types-allow-isdashed">Dashed</Form.Label>
                        <div className="d-flex align-items-center">
                            <Form.Check type='switch' id="types-allow-isdashed" checked={ isDashed } onChange={ e => setIsDashed(e.target.checked) } />
                        </div>
                    </Form.Group>
                }
            </ConfigurationDialog>

            <WorkflowConfigFieldsForm workflowHasData={workflowHasData} fieldsType="fields" typeFormData={typeFormData} setTypeFormData={setTypeFormData} editModeData={ editedFieldsFormData } showFieldsForm={ showFieldsForm } setShowFieldsForm={ setShowFieldsForm } onSubmitFields={ fieldsData => {
                if (editedFieldsFormData) {
                    editConfigFields("fields", fieldsData, editableConfigFieldIndex)
                } else addConfigFields("fields", fieldsData)
            } } onCancel={() => setEditedFieldsFormData(null)} />

            <WorkflowConfigFieldsForm workflowHasData={workflowHasData} fieldsType="attachmentFields" typeFormData={typeFormData} setTypeFormData={setTypeFormData} editModeData={ editedAttachmentFieldsFormData } showFieldsForm={ showAttachmentFieldsForm } setShowFieldsForm={ setShowAttachmentFieldsForm } onSubmitFields={ fieldsData => {
                if (editedAttachmentFieldsFormData) {
                    editConfigFields("attachmentFields", fieldsData, editableConfigFieldIndex)
                } else addConfigFields("attachmentFields", fieldsData)
            }} onCancel={() => setEditedAttachmentFieldsFormData(null)} />

            <ConfigurationDialog
                show={ showImageDialog }
                title='Select Icon'
                onSave={ () => {
                    setShowImageDialog(false);
                    onSave();
                } }
                onCancel={ () => {
                    setShowImageDialog(false);
                } }
                hideSave={true}
                preventSave={ !canSave }
            >
                <Form.Group>
                    <FilterBar value={filter} onChange={setFilter} className="mb-4" />

                    <SimpleBar autoHide={false} className='simplebar-no-autohide pe-3' style={{ maxHeight: 'calc(100vh - 380px)', minHeight: 'calc(100vh - 380px)' }}>
                        { isLoadingIcons && <Loading />}
                        {
                            !arrayUtilities.isNullOrEmpty(filteredIcons) && filteredIcons.map(node => renderTree(node))
                        }
                    </SimpleBar>
                </Form.Group>
            </ConfigurationDialog>

            {
                showAttachmentTypesModal && 
                    <Modal show onHide={ () => {
                        setAttachmentType(null)
                        setShowAttachmentTypesModal(false);
                    } } centered>
                        <Modal.Header>
                            <Modal.Title>Add attachment type</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <SimpleBar autoHide={ false } className='simplebar-no-autohide pe-3' style={ { maxHeight: 'calc(100vh - 380px)' } }>
                                <Textbox label="Name" value={ attachmentType } onChange={ setAttachmentType } />
                            </SimpleBar>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button size="sm" variant='secondary' onClick={ () => {
                                setAttachmentType(null)
                                setShowAttachmentTypesModal(false);
                            } }>Cancel</Button>
                            <Button disabled={ stringUtilities.isNullOrEmpty(attachmentType) } size="sm" variant="primary" onClick={ () => {
                                if (editableAttachmentTypeIndex !== null) {
                                    editAttachmentType(editableAttachmentTypeIndex)
                                } else addAttachmentType()
                            } }>Submit</Button>
                        </Modal.Footer>
                    </Modal>
            }

            {
                deleteItem !== null &&
                <Modal show onHide={ () => setDeleteItem(null) } centered>
                    <Modal.Header>
                        <Modal.Title>Delete {deleteItem.section}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            workflowHasData 
                            ? <> This workflow has data attached to it. Deleting this entry could lead to loss of data. Please proceed with caution.</>
                            : <>Are you sure?</>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setDeleteItem(null)}>Cancel</Button>
                        <Button size="sm" variant="danger" onClick={ () => deleteRowItem(deleteItem) }>Delete</Button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    )
}